import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25080467"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4 mb-10" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "text-lg font-bold" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 bg-gray-200 font-bold p-4 rounded-md shadow-md" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "py-10"
}
const _hoisted_10 = { class: "flex flex-col items-center gap-4 py-8" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-h-primary-800" }, null, -1))
const _hoisted_12 = { class: "text-lg text-gray-600" }
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = { class: "text-lg font-bold w-full text-center" }
const _hoisted_15 = {
  id: "question-types",
  class: "border-t pt-8"
}
const _hoisted_16 = { class: "w-full grid grid-cols-1 lg:grid-cols-2 gap-5" }
const _hoisted_17 = { class: "grid" }
const _hoisted_18 = ["for"]
const _hoisted_19 = {
  key: 0,
  class: "bg-gray-50 mt-5 p-5 text-center font-light"
}
const _hoisted_20 = {
  key: 1,
  id: "buttons",
  class: "flex justify-end border-t mt-5 pt-5 gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneratedQuizQuestions = _resolveComponent("GeneratedQuizQuestions")!
  const _component_QuestionCard = _resolveComponent("QuestionCard")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("quiz.teacher.questions")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.hasGeneratedQuestions)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.role === 'TEACHER')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      id: "btn-save-all-questions",
                      label: 
              _ctx.$t('labels.generic', {
                pt: 'Salvar Questões',
                en: 'Save Questions',
              })
            ,
                      class: "btn-success p-button-sm",
                      icon: "pi pi-save",
                      disabled: _ctx.generatedQuestions.length === 0,
                      loading: _ctx.savingAllQuestions,
                      onClick: _ctx.saveAllGeneratedQuestions
                    }, null, 8, ["label", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (!_ctx.loader)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.role === 'TEACHER')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        id: "btn-add-questions",
                        label: _ctx.$t('quiz.teacher.add'),
                        class: "btn-primary p-button-sm",
                        icon: "pi pi-plus",
                        disabled: !_ctx.quizId,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openQuestionOptions()))
                      }, null, 8, ["label", "disabled"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.hasGeneratedQuestions)
        ? (_openBlock(), _createBlock(_component_GeneratedQuizQuestions, {
            key: 0,
            questions: _ctx.generatedQuestions,
            role: _ctx.role,
            quizId: _ctx.quizId,
            onQuestionsUpdated: _ctx.onGeneratedQuestionsUpdated
          }, null, 8, ["questions", "role", "quizId", "onQuestionsUpdated"]))
        : _createCommentVNode("", true),
      (!_ctx.hasGeneratedQuestions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("quiz.teacher.list")), 1),
              (!_ctx.loader)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.questionsLocal?.length) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "Questões", en: "Questions" })), 1))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.loader)
              ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsLocal, (question, index) => {
                    return (_openBlock(), _createBlock(_component_QuestionCard, {
                      key: index,
                      question: question,
                      questionIndex: index,
                      loadBtn: _ctx.loadBtn,
                      role: _ctx.role,
                      isGeneratingQuiz: _ctx.generateQuizLoading,
                      onGoToQuestion: _ctx.goToQuestion,
                      onDeleteQuestion: _ctx.deleteQuestion
                    }, null, 8, ["question", "questionIndex", "loadBtn", "role", "isGeneratingQuiz", "onGoToQuestion", "onDeleteQuestion"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.questionsLocal || (_ctx.questionsLocal.length === 0 && !_ctx.loader))
              ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                  (!_ctx.generateQuizLoading)
                    ? (_openBlock(), _createBlock(_component_EmptyData, {
                        key: 0,
                        data: !_ctx.questionsLocal || _ctx.questionsLocal.length === 0,
                        label: _ctx.emptyState.description,
                        image: _ctx.emptyState.image,
                        imgSize: "h-24"
                      }, null, 8, ["data", "label", "image"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Loader, {
      loader: _ctx.loader,
      loaderSize: "h-48"
    }, null, 8, ["loader"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.generateQuizLoading,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generateQuizLoading) = $event)),
      draggable: false,
      closable: false,
      style: { width: '400px' },
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Gerando questões...",
            en: "Generating questions...",
          })), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("labels.generic", { pt: "Aguarde...", en: "Please wait..." })), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.questionDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.questionDialog) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '35vw', minWidth: '360px' },
      onHide: _ctx.closeQuestionOptions,
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Criar nova questão",
            en: "Create new question",
          })), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionTypes, (type, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "w-full"
              }, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.questionTypeSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.questionTypeSelected) = $event)),
                  inputId: type.value,
                  value: type,
                  class: "!hidden"
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    for: type.value,
                    class: _normalizeClass([
                type.value === _ctx.questionTypeSelected?.value &&
                  'bg-h-primary-50 border-2 border-h-primary-700',
                ' rounded p-5 text-center cursor-pointer border border-h-primary-400 text-h-primary-800 hover:opacity-75 transition-all flex items-center gap-3',
              ])
                  }, [
                    _createVNode(_component_v_icon, {
                      name: type.icon
                    }, null, 8, ["name"]),
                    _createElementVNode("p", null, _toDisplayString(type.name), 1)
                  ], 10, _hoisted_18)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.questionTypeSelected?.info)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.questionTypeSelected?.info), 1))
            : _createCommentVNode("", true),
          (_ctx.questionTypeSelected?.value || _ctx.questionTypeSelected?.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_Button, {
                  class: "btn-outline p-button-sm",
                  onClick: _ctx.closeQuestionOptions,
                  disabled: _ctx.generateQuizLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  class: _normalizeClass(`btn-primary p-button-sm ${
            _ctx.questionTypeSelected?.value === '' && 'disabled'
          }`),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chooseQuestionType())),
                  disabled: _ctx.generateQuizLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.proceed")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}